import React from 'react';
import styles from './CopyRight.module.css';
import { FaRegCopyright } from 'react-icons/fa';

const CopyRight = () => {
  return (
    <div className={styles.container}>
      <FaRegCopyright className={styles.icon} />
      <span className={styles.text}>School Technology Inr. All rights reserved</span>
    </div>
  );
};

export default CopyRight;
